import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';
@Component({
  selector: 'app-pedidos',
  templateUrl: './pedidos.component.html',
  styleUrls: ['./pedidos.component.css']
})
export class PedidosComponent {

  //DATOS
  pedidosData: any;
  beersData: any;
  devicesData: any;
  establecimientosData: any;
  tablaData: any [] = [];

  //ERROR
  errorMessage : string = "";

  //TABLA
  datosRecibidos: boolean = false;
  displayedColumns: string[] = ['ordered_at', 'external_id', 'est_name', 'numero_tank', 'litros' ,'cerveza'];
  dataSource :any;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  userDataInfo: any = [];
  clientsData: any = [];

  //SUBSCRIPCIONES
  private tanksSubscription: Subscription | undefined;
  private clientsSubscription: Subscription | undefined;

  constructor(private deviceService: DeviceService, private error429: Error429Service, 
    private userDataService: UserDataService, private userService: UserService){
    this.userDataInfo = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    if(this.userDataInfo.pro_id == 4){
      this.displayedColumns = ['ordered_at', 'external_id', 'est_name', 'client_name' ,'numero_tank', 'litros' ,'cerveza'];
    }
    const start = "2015-01-01"
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1);
    this.clientsSubscription = this.userService.getClients().subscribe({
      next:resp =>{
        this.clientsData = resp;
      }, error: err => {
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () => {
        this.tanksSubscription = this.deviceService.getPedidos(start,currentDate.toISOString().slice(0, 10)).subscribe({
          next:resp =>{
            console.log(resp);
            for(let i = 0; i<resp.orders.length; i++){
              const beerTypeName = resp.orders[i]?.beertype?.name || "-";
              this.tablaData.push({
                est_id: resp.orders[i].establishment_id, 
                external_id: resp.orders[i].establishment?.external_id,
                est_name: resp.orders[i].establishment.est_name, 
                numero_tank: resp.orders[i].tank_num, 
                litros: this.soloDosDecimalesConComa(resp.orders[i].litres_requested),
                cerveza: beerTypeName,
                ordered_at: resp.orders[i].ordered_at,
                client_name: this.obtenerNombreCliente(resp.orders[i].client_id),
              })
            }
          },error:err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          }, complete:()=>{
            this.dataSource = new MatTableDataSource(this.tablaData); 
            //Filtrado personalizado para que no tenga en cuenta el id del tanque.
            this.dataSource.filterPredicate = (data: any, filter: string) => {
              if(this.userDataInfo.pro_id == 4){
                const dataStr = this.displayedColumns
                .filter(key => key !== 'est_id')
                .map(key => data[key])
                .join('')
                .toLowerCase();
          
                return dataStr.includes(filter);
              } else {
                const dataStr = this.displayedColumns
                .filter(key => key !== 'est_id' && key!== 'client_name')
                .map(key => data[key])
                .join('')
                .toLowerCase();
          
                return dataStr.includes(filter);
              }
            };
            setTimeout(() => {
              this.dataSource.sort = this.sort;
              this.dataSource.paginator = this.paginator;
            },0)
            this.datosRecibidos = true;
          }
        });
      }
    })
  }

  soloDosDecimalesConComa(numero: number){
    if(Number.isNaN(numero)){
      return 0
    } else {
      return numero.toLocaleString(this.userDataInfo.region, { maximumFractionDigits: 2 });
    }
  }

  obtenerNombreCliente(id:number): string {
    const cliente = this.clientsData.find((cliente:any)=> cliente.id == id)
    return cliente ? cliente.razon_social : 'Cliente no encontrado';
  }

  obtenerNombreCerveza(id: number): string {
    const cerveza = this.beersData.find((beer:any) => beer && beer.id === id);
    return cerveza ? cerveza.name : 'Cerveza no encontrada';
  }

  obtenerNombreDispositivo(id: number): string {
    const device = this.devicesData.find((device:any) => device && device.id === id);
    return device ? device.dev_label : 'Dispositivo no encontrado';
  }

  obtenerReferenciaDispositivo(id: number): string {
    const device = this.devicesData.find((device:any) => device && device.id === id);
    return device ? device.dev_reference : 'Dispositivo no encontrado';
  }

  obtenerNombreEstablecimiento(id: number): string{
    const device = this.devicesData.find((device:any) => device && device.id === id);
    if(device != undefined){
      const establecimiento = this.establecimientosData.find((establecimiento:any) => establecimiento && establecimiento.id === device.dev_est_id);
      return establecimiento ? establecimiento.est_name : 'Establecimiento no encontrado';
    } else {
      return 'No encontrado';
    }
  }

  obtenerIDEstablecimiento(id: number): string{
    const device = this.devicesData.find((device:any) => device && device.id === id);
    if(device != undefined){
      const establecimiento = this.establecimientosData.find((establecimiento:any) => establecimiento && establecimiento.id === device.dev_est_id);
      return establecimiento ? establecimiento.id : 'Establecimiento no encontrado';
    } else {
      return 'No encontrado';
    }
  }

  ngOnDestroy(): void {
    if (this.tanksSubscription) {
      this.tanksSubscription.unsubscribe();
    } 
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  
  descargarExcel(){
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');

    worksheet.columns = [
      { header: 'Fecha del Pedido', key: 'ordered_at', width: 30 },
      { header: 'Establecimiento ID', key: 'external_id', width: 20 },
      { header: 'Establecimiento', key: 'est_name', width: 20 },
      ...(this.userDataInfo.pro_id === 4 ? [{ header: 'Cliente', key: 'client_name', width: 30 }] : []),
      { header: 'Num. de Tanque', key: 'numero_tank', width: 20 },
      { header: 'Litros Pedidos', key: 'litros', width: 30 },
      { header: 'Producto', key: 'cerveza', width: 30 },
      //{ header: 'Capacidad (L)', key: 'capacidad', width: 30 },
    ];

    this.tablaData.forEach(tanque => {
      const row = worksheet.addRow(tanque);
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        const columnWidth = cell.text.length + 3;
        const currentColumn = worksheet.getColumn(colNumber);
        if (currentColumn) {
          currentColumn.width = Math.max(currentColumn.width || 0, columnWidth);
        }
      });
    });
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Listado de pedidos DataBeer.xlsx');
    });
  }
}
